<template>
  <div class="text-center">
    <img 
      src="@/assets/empty-program.jpg"
      alt="磐石保經線上投保平台 - 搜尋結果"
      width="180"
      height="180"
    >
    <h3 :style="{marginTop: '15px', color: '#606266'}">找不到符合的方案，請重新搜尋。</h3>
  </div>
</template>

<script>
  export default {
    props: {
      triggerScrollToProd: {
        type: Function,
        default: () => {}
      }
    },
    mounted() {
      this.triggerScrollToProd();
    }
  };
</script>